import React, {Component} from 'react';
import {withStyles} from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import IconButton from "@material-ui/core/IconButton";
import DeleteIcon from "@material-ui/icons/Delete";
import _ from 'lodash';
import Sortable from 'react-sortablejs';
import Tooltip from "@material-ui/core/Tooltip";
import DragHandle from "@material-ui/icons/DragHandle";
import Grid from "@material-ui/core/Grid";

const styles = theme => ({
    root: {
        width: '100%',
        marginTop: theme.spacing(3),
        overflowX: 'auto',
    },
    table: {
        minWidth: 650,
    },
    positionInput: {
        width: 50
    }
});

class PlaylistMomentClips extends Component {


    constructor(props) {
        super(props);

    }


    render() {
        let sortable = null; // sortable instance

        const {classes, theme} = this.props;

        return (<Paper className={classes.root}>
                    <>
                    <Table className={classes.table}>
                        <TableHead>
                            <TableRow>
                                <TableCell align="right">Moment ID</TableCell>
                                <TableCell>Moment Title</TableCell>
                                <TableCell>Position</TableCell>
                                <TableCell>CID</TableCell>
                                <TableCell>Start Time</TableCell>
                                <TableCell>End Time</TableCell>
                                <TableCell>Actions</TableCell>
                            </TableRow>
                        </TableHead>


                        <Sortable
                            options={{handle: '.handler'}}

                            // [Optional] Use ref to get the sortable instance
                            // https://facebook.github.io/react/docs/more-about-refs.html#the-ref-callback-attribute
                            ref={(c) => {
                                if (c) {
                                    sortable = c.sortable;
                                }
                            }}

                            tag={'tbody'}
                            // [Optional] A tag or react component to specify the wrapping element. Defaults to "div".
                            // In a case of a react component it is required to has children in the component
                            // and pass it down.

                            onChange={(order, sortable, evt) => {
                                this.props.onChange(order);
                            }}
                            // [Optional] The onChange method allows you to implement a controlled component and keep
                            // DOM nodes untouched. You have to change state to re-render the component.
                            // @param {Array} order An ordered array of items defined by the `data-id` attribute.
                            // @param {Object} sortable The sortable instance.
                            // @param {Event} evt The event object.

                        >
                            {_.map(this.props.momentClips, ((row, index) => (
                                <TableRow key={row.momentClip.id} data-id={row.momentClip.id}>
                                    <TableCell align="right">{row.momentClip.id}</TableCell>
                                    <TableCell>{row.momentClip.title}</TableCell>
                                    <TableCell>{row.position}</TableCell>
                                    <TableCell>{row.momentClip.cid}</TableCell>
                                    <TableCell>{row.momentClip.startTime}</TableCell>
                                    <TableCell>{row.momentClip.endTime}</TableCell>
                                    <TableCell>
                                        <Grid container spacing={0} direction="row" justify="space-between" alignItems={"center"}>


                                            <Grid item xs={4}>
                                                <Tooltip  title="Drag this to reorder" aria-label="Drag this to reorder">
                                                    <IconButton onClick={(event) => {
                                                        event.preventDefault()
                                                    }} class={'handler MuiButtonBase-root MuiIconButton-root'}>

                                                        <DragHandle fontSize={"small"} className={classes.dragDropIcon}/>
                                                    </IconButton>
                                                </Tooltip>
                                            </Grid>

                                            <Grid item xs={4}>

                                            </Grid>
                                            <Grid item xs={4}>

                                                <Tooltip title="Remove Clip Moment from this playlist." aria-label="Remove Clip Moment from this playlist.">
                                                    <IconButton aria-label="delete"
                                                                onClick={this.props.removeMomentClip.bind(this, row.momentClip.id)}
                                                                className={classes.button}>
                                                        <DeleteIcon fontSize="small"/>
                                                    </IconButton>
                                                </Tooltip>


                                            </Grid>
                                        </Grid>

                                    </TableCell>
                                </TableRow>

                            )))}

                        </Sortable>

                    </Table>
                    </>
            </Paper>
        )
    };
}


export default (withStyles(styles, {withTheme: true})(PlaylistMomentClips));